module.exports = __webpack_public_path__ + "static/media/Error-404.42a8d8ab.png";